"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastBaseWidget = exports.ToastSpacing = exports.ToastHeight = exports.ToastMessageTestIdSuffix = exports.ToastContentTestIdSuffix = exports.ToastDivTestIdSuffix = exports.ToastType = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var CloseButtonWidget_1 = require("../Button/CloseButtonWidget");
var TextLinkWidget_1 = require("../TextLinkWidget");
var DefaultActionHref = 'javascript:void(0)';
var ToastType;
(function (ToastType) {
    ToastType["Error"] = "error";
    ToastType["Warning"] = "warning";
    ToastType["Success"] = "success";
    ToastType["Info"] = "info";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
var toastBackgroundColors = (_a = {},
    _a[ToastType.Error] = {
        backgroundColor: 'rgb(248,199,203)',
    },
    _a[ToastType.Warning] = {
        backgroundColor: 'rgb(255,214,187)',
    },
    _a[ToastType.Info] = {
        backgroundColor: 'rgb(215,236,249)',
    },
    _a[ToastType.Success] = {
        backgroundColor: 'rgb(172,229,200)',
    },
    _a);
exports.ToastDivTestIdSuffix = 'toast-widget';
exports.ToastContentTestIdSuffix = 'toast-content';
exports.ToastMessageTestIdSuffix = 'toast-message';
exports.ToastHeight = 42;
exports.ToastSpacing = 8;
var FontSize = TabStyles_1.TabStyles.Typography.Sizing.Default;
var LineHeight = 1.5 * FontSize;
var toastStyles = {
    toastDiv: {
        alignItems: 'flex-start',
        boxShadow: TabStyles_1.TabStyles.Shadow.Standard,
        boxSizing: 'border-box',
        color: '#333',
        display: 'inline-flex',
        flexDirection: 'row',
        fontSize: FontSize,
        justifyContent: 'flex-start',
        marginBottom: 3,
        minHeight: exports.ToastHeight,
        padding: exports.ToastSpacing * 1.5 + "px " + exports.ToastSpacing * 3 + "px",
        position: 'relative',
        visibility: 'visible',
    },
    contentDiv: {
        display: 'flex',
        lineHeight: LineHeight + "px",
    },
    prefix: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    messageContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: -exports.ToastSpacing,
    },
    message: {
        margin: "0 " + exports.ToastSpacing + "px",
        marginBottom: exports.ToastSpacing,
    },
    actionContainer: {
        marginBottom: exports.ToastSpacing,
    },
    actionLink: {
        marginLeft: exports.ToastSpacing - 1,
    },
    closeButton: {
        cursor: 'pointer',
        flexShrink: 0,
        margin: 0,
        marginLeft: exports.ToastSpacing * 2,
        minHeight: LineHeight,
        minWidth: LineHeight,
    },
};
var actionLinkStyleOverrideClass = TypeStyle.style({
    $nest: {
        '&&': {
            color: '#333',
            $nest: {
                '&:hover': {
                    color: '#333',
                },
                '&:active': {
                    color: '#000',
                },
            },
        },
    },
});
function prefixForToastType(toastType) {
    // tslint:disable-next-line:no-any
    return React.createElement("b", { style: toastStyles.prefix }, Localize_1.Messages[toastType + 'ToastPrefix']());
}
exports.ToastBaseWidget = function (props) {
    var actionHref = props.actionHref, actionMessage = props.actionMessage, children = props.children, message = props.message, onAction = props.onAction, onCloseRequest = props.onCloseRequest, testId = props.testId, toastType = props.toastType, htmlProps = tslib_1.__rest(props, ["actionHref", "actionMessage", "children", "message", "onAction", "onCloseRequest", "testId", "toastType"]);
    var toastStyle = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, toastStyles.toastDiv), toastBackgroundColors[toastType]), htmlProps.style);
    var prefix = prefixForToastType(toastType);
    var handleActionLinkClick = React.useCallback(function (e) {
        if (onAction || actionHref === DefaultActionHref) {
            e.preventDefault();
            onAction === null || onAction === void 0 ? void 0 : onAction();
        }
    }, [onAction]);
    return (React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, exports.ToastDivTestIdSuffix) }, htmlProps, { style: toastStyle }),
        React.createElement("div", { style: toastStyles.contentDiv, "data-tb-test-id": Declarative_1.makeTestId(testId, exports.ToastContentTestIdSuffix) },
            prefix,
            React.createElement("div", { style: toastStyles.messageContainer },
                React.createElement("div", { style: toastStyles.message, role: 'alert', "data-tb-test-id": Declarative_1.makeTestId(testId, exports.ToastMessageTestIdSuffix) },
                    React.createElement("span", { style: { position: 'absolute', color: 'transparent' } }, prefix),
                    message,
                    children),
                React.createElement("div", { style: toastStyles.actionContainer }, actionMessage &&
                    React.createElement(TextLinkWidget_1.TextLinkWidget, { children: actionMessage, className: actionLinkStyleOverrideClass, href: actionHref, kind: TextLinkWidget_1.TextLinkKind.Lightweight, onClick: handleActionLinkClick, style: toastStyles.actionLink, target: '_blank', testId: testId })))),
        React.createElement(CloseButtonWidget_1.CloseButtonWidget, { className: 'prominent', "data-tb-test-id": 'toast-close-Button', onClick: onCloseRequest, style: toastStyles.closeButton, testId: null })));
};
exports.ToastBaseWidget.displayName = 'ToastBaseWidget';
exports.ToastBaseWidget.defaultProps = { actionHref: DefaultActionHref };
//# sourceMappingURL=ToastBase.js.map